var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.47 35.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".steam_svg{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "steam_svg",
    d: "M30.84,0H4.63C2.07,0,0,2.07,0,4.63v12.75l6.82,2.66s1.76-2.53,5.38-2.51c1.58-2.36,4.05-5.4,4.05-5.4,0,0-.17-3.83,2.81-6.47s6.64-2.62,8.84-1.74c2.19,.87,5.85,3.38,5.68,8.89-.17,5.52-5.57,8.3-9.34,7.96-2.73,2.17-4.73,3.55-4.73,3.55,0,0,.43,5.04-4.37,7.18-4.8,2.14-9.86-1.09-10.24-6.72-3.15-1.16-4.91-1.91-4.91-1.91v7.98c0,2.56,2.07,4.63,4.63,4.63H30.84c2.56,0,4.63-2.07,4.63-4.63V4.63c0-2.56-2.07-4.63-4.63-4.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "steam_svg",
    d: "M24.97,17.03c-2.86,0-5.19-2.33-5.19-5.19s2.33-5.19,5.19-5.19,5.19,2.33,5.19,5.19-2.33,5.19-5.19,5.19Zm0-9.05c-2.13,0-3.87,1.73-3.87,3.87s1.73,3.87,3.87,3.87,3.87-1.73,3.87-3.87-1.73-3.87-3.87-3.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "steam_svg",
    d: "M10.13,21.33l1.85,.72s1.42-.3,2.55,1.01c1.13,1.32,.67,3.16-.29,3.95s-2.03,.97-3.13,.45-2.73-1.31-2.73-1.31c0,0,.03,.58,.83,1.52s2.38,1.72,4.2,1.28,2.86-2,3.05-3.39-.2-2.97-1.72-4.11-3.68-.8-4.6-.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/Steam.b58d01c23c16d40440929c1899370310.svg";
export { ForwardRef as ReactComponent };